import { gql } from '@apollo/client';

export const GET_OATT_VENDORS = gql`
  query GetOattVendors {
    oattVendors {
      oatt_vendor_info_id
      customer_code
      contact_name
      company_name
      address_line1
      address_line2
      address_line3
      account_number
      apply_hst
      vendor_comment
      created_at
      updated_at
    }
  }
`;

export const UPDATE_OATT_VENDOR = gql`
  mutation UpdateOattVendor($input: UpdateOattVendorInput!) {
    updateOattVendor(input: $input) {
      success
      message
      data {
        oatt_vendor_info_id
        customer_code
        contact_name
        company_name
        address_line1
        address_line2
        address_line3
        account_number
        apply_hst
        vendor_comment
        updated_at
      }
    }
  }
`;
